import React, { ReactNode } from 'react';
import classNames from 'classnames';
import css from './Count.module.css';
import { BarChartOutlined } from '@ant-design/icons';

type Props = {
  className?: string;
  value?: number | string;
  icon?: ReactNode;
} & React.HTMLProps<HTMLDivElement>;

export const Count = ({ className, value, icon, ...rest }: Props) => {
  return (
    <div className={classNames(className, css.container)} {...rest}>
      <div className={css.icon}>{icon || <BarChartOutlined />}</div>
      <span className={css.count}>{value}</span>
    </div>
  );
};
